import React, {useEffect, useState} from 'react';
import moment from 'moment';
import POCToolCategory from './POCToolCategory';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {SuperPOCTool} from '../../../models/IPOCToolWebPortal';
import {ApplicationState} from '../../../store';
import {useParams} from 'react-router-dom';
import {Box, Typography} from '@mui/material';
import {actionCreators} from '../../../store/POCToolsWebPortal/POCToolsWebPortalActions';
import Button from '@mui/material/Button';
import Loader from '../generalPurpose/Loader';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {poctoolCategoriesToDisplayBySearch} from '../../../Util/PocToolsSearchFilter';
import SearchBar from './SearchBar';
import PageContainer from './PageContainer';
import {sanitizeURL} from '../../../Util/sanitizeURL';

export default function MiniToolContentSinglePage() {
  const {POCToolId, minitoolId} = useParams();

  const [searchQuery, setSearchQuery] = useState('');
  const [isOpen, setisOpen] = useState(false);

  const dispatch = useAppDispatch();

  const pointOfCareTool: SuperPOCTool = useAppSelector(
    (state: ApplicationState) => state.POCToolsWebPortal.superPointOfCareTool,
  );
  const isLoading = useAppSelector(
    (state: ApplicationState) => state.POCToolsWebPortal.isLoading,
  );

  if (!pointOfCareTool.id) {
    dispatch(actionCreators.getMiniPOCToolById(POCToolId));
  }
  const onChangeSearch = query => {
    setSearchQuery(query.target.value);
  };
  const handleCollapse = () => {
    setisOpen(!isOpen);
  };

  const thisMinitool = pointOfCareTool?.miniTools.find(
    miniTool => miniTool.id === minitoolId,
  );

  const pocToolToDisplay = poctoolCategoriesToDisplayBySearch(
    pointOfCareTool,
    searchQuery,
  );
  const date = moment(pointOfCareTool?.lastUpdated)
    .format('MM/DD/YYYY')
    .toString();
  const description =
    pointOfCareTool.description ?? 'No description available.';

  useEffect(() => {
    dispatch(actionCreators.getMiniToolContent(POCToolId, minitoolId));
  }, []);

  useEffect(() => {
    if (pointOfCareTool.id === POCToolId) {
      document.title = `${pointOfCareTool?.name} | ACEP`;
    }
  }, [pointOfCareTool]);

  const pointOfCareToolName = pointOfCareTool.name;
  const encodedToolName = sanitizeURL(pointOfCareToolName);

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <PageContainer
        links={[
          {name: 'Point-of-Care Tools', url: '../'},
          {
            name: pointOfCareTool?.name,
            url: `../MiniTools/${encodedToolName}/${pointOfCareTool.id}/`,
          },
          {
            name: thisMinitool?.name,
            url: '',
          },
        ]}
        isThereBackButton
        BackButtonTitle={`Back to ${pointOfCareTool?.name}`}>
        <Box>
          <h1 style={styles.textTitle}>{thisMinitool?.name}</h1>
          <p style={styles.textLastUpdated}>Updated on {date}</p>
          <p style={styles.textDescription}>{description}</p>
        </Box>
        <Box paddingBottom={2}>
          <SearchBar
            searchQuery={searchQuery}
            onChangeSearch={onChangeSearch}
          />
        </Box>
        <Box style={styles.collapseButtonContainer}>
          <Button
            variant="outlined"
            style={styles.collapseButton}
            onClick={handleCollapse}
            endIcon={isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
            <Typography style={{textTransform: 'initial', color: '#1976D2'}}>
              {isOpen ? 'Collapse All' : 'Expand All'}
            </Typography>
          </Button>
        </Box>
        <Box>
          {pocToolToDisplay
            ?.slice()
            .sort((a, b) => a.order - b.order)
            .map(category => (
              <POCToolCategory
                key={category.id}
                category={category}
                isOpen={isOpen}
              />
            ))}
        </Box>
      </PageContainer>
    </div>
  );
}

const styles = {
  container: {
    paddingTop: 21,
    marginBottom: '5%',
  },
  textTitle: {
    fontSize: 28,
    fontWeight: '600',
    marginBottom: 10,
  },
  textLastUpdated: {
    fontSize: 14,
    fontcolor: '#333333',
    fontWeight: '400',
    marginBottom: 26,
  },
  textDescription: {
    fontSize: 18,
    fontcolor: '#000000',
    fontWeight: '400',
  },
  subDescription: {
    fontSize: 17,
    marginTop: 42,
    fontWeight: '400',
    lineHeight: '140%',
  },
  collapseButtonContainer: {
    display: 'flex',
    justifyContent: 'end',
    paddingBottom: 20,
  },
  collapseButton: {
    borderRadius: 100,
    borderWidth: 2,
    borderColor: '#1976D2',
  },
};
